export default __webpack_public_path__ + "static/media/guestyLogo.56e21dfc.svg";